<template>
  <div>
    <!-- 已退款待确认 -->
    <baseBreadcrumb :menu="$t('message.money')" :page="$t('message.refundedPendingConfirmation')"></baseBreadcrumb>
    <div class="body">
      <div class="tabs">
        <div class="item" v-for="(it, index) in tab" :key="index" @click="searchTabs(it.key)"
          :class="{ 'active': it.key === datas.audit_status }">
          <span>{{ it.label }} {{ index === 0 ? '' : ` (${it.value}) ` }}</span>
        </div>
      </div>
      <!-- 搜索 -->
      <div class="search">
        <!-- 交易号 -->
        <div class="item">
          <el-input v-model="datas.purchase_no" :placeholder="$t('message.transactionNumber')" clearable></el-input>
        </div>
        <!-- 订单号 -->
        <div class="item">
          <el-input v-model="datas.order_sn" :placeholder="$t('message.orderNumber')" clearable></el-input>
        </div>
        <!-- 客户ID -->
        <div class="item">
          <el-input v-model="datas.user_id" :placeholder="$t('message.clientID')" clearable></el-input>
        </div>
        <!-- 采购 -->
        <div class="item">
          <el-select v-model="datas.g_id" clearable filterable :placeholder="$t('message.buyer')">
            <el-option v-for="item in g" :key="item.id" :label="item.realname" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <!-- 业务 -->
        <div class="item">
          <el-select v-model="datas.y_id" clearable filterable :placeholder="$t('message.salesman')">
            <el-option v-for="item in y" :key="item.id" :label="item.realname" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <!-- 配货员 -->
        <div class="item">
          <el-select v-model="datas.p_id" clearable filterable :placeholder="$t('message.distributionMember')">
            <el-option v-for="item in p" :key="item.id" :label="item.realname" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <!-- 是否有凭证 -->
        <div class="item">
          <el-select v-model="datas.has_refund_image" clearable filterable :placeholder="$t('message.hasRefundImage')">
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </div>
        <!-- 是否发起售后 -->
        <div class="item">
          <el-select v-model="datas.has_refund" clearable filterable :placeholder="$t('message.isAfterSale')">
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="2"></el-option>
          </el-select>
        </div>
        <!--搜索 -->
        <el-button type="primary" @click="search">{{ $t('message.search') }}</el-button>
        <el-button @click="reset">{{ $t('message.reset') }}</el-button>
      </div>
      <!-- 列表 -->
      <div class="table" :style="{ height: tableautoheight + 'px' }">
        <ol>

          <!-- 客户订单号 -->
          <li>{{ $t('message.customerOrderNumber') }}</li>
          <!-- 商品信息 -->
          <li>{{ $t('message.commodityInformation') }}</li>
          <!-- 客户信息 -->
          <li>{{ $t('message.userInfo') }}</li>
          <!-- 退款数量 -->
          <li class="flex05">{{ $t('message.refundQuantity') }}</li>
          <!-- 问题产品退款商品金额（CNY） -->
          <li class="Warning">{{ $t('message.problemProductRefundedAmountIn') }}</li>
          <!-- 问题产品采购处理完成时间 -->
          <li class="Warning">{{ $t('message.problemProductPurchaseProcessingCompletionTime') }}</li>
          <!-- 采购成本 -->
          <li class="Warning">{{ $t('message.purchaseChengBen') }}</li>
          <!-- 退款凭证 -->
          <li class="Warning">{{ $t('message.refundVoucher') }}</li>
          <!-- 1688该交易号是否发起售后 -->
          <li class="Danger">{{ $t('message.isAfterSaleIn1688') }}</li>
          <!-- 售后单号 -->
          <li class="Danger">{{ $t('message.afterSaleOrderNumber') }}</li>
          <!-- 售后状态 -->
          <li class="Danger flex05">{{ $t('message.afterSaleStatus') }}</li>
          <!-- 1688该交易号售后完成时间 -->
          <li class="Danger">{{ $t('message.afterSaleCompletionTimeIn1688') }}</li>
          <!-- 1688退款商品金额CNY -->
          <li style="color: #fff;background-color: #8C0CEE;">{{ $t('message.refundedAmountIn1688') }}</li>
          <!-- 收入账号（支付宝/银行） -->
          <li class="Danger">{{ $t('message.incomeAccount') }}</li>
          <!-- 到账状况 -->
          <li class="Danger flex05">{{ $t('message.arrivalStatus') }}</li>
          <!-- 退款到账时间 -->
          <li class="Danger">{{ $t('message.refundArrivalTime') }}</li>
          <!-- 审核状态 -->
          <li class="flex05">{{ $t('message.auditStatus') }}</li>
          <!-- 财务审核备注 -->
          <li>{{ $t('message.financialAuditRemark') }}</li>
          <!-- 操作 -->
          <li class="operation ">{{ $t('message.operation') }}</li>
        </ol>
        <div class="tableData" v-for="(itemData, detailIndex) in tableData" :key="detailIndex">
          <ul class="tableHead">
            <!-- 交易号 -->
            <li class="cashback-header" style="flex: 3; justify-content: flex-start; ">
              <p class="purchase-number" :title="itemData.purchase_no"> 交易号： {{ itemData.purchase_no }}</p>
              <!-- 781：查看收款，复用问题产品页的收款明细、创建和作废弹框。 -->
              <span v-if="isAuth(781)" class="cashback-entry">
                <el-button type="success" size="mini" :disabled="!itemData.purchase_no"
                  @click="$refs.purchaseCashbackList.open(itemData.purchase_no)">
                  {{ $t('message.cashbackCollectionLink') }}
                </el-button>
                <!-- 全部已作废时隐藏摘要，明细仍保留全部记录。 -->
                <span v-if="itemData.cashbackEntry.latest" class="cashback-latest"
                  :class="{ paid: itemData.cashbackEntry.latest.status === 'paid', pending: itemData.cashbackEntry.latest.status === 'pending' }">
                  {{ itemData.cashbackEntry.latest.amount }} {{ itemData.cashbackEntry.latest.status_name }}
                </span>
              </span>
            </li>

            <!-- 退款数量 -->
            <li class="flex05">
              {{ itemData.total_refund_num }}
            </li>
            <!-- 问题产品退款商品金额（CNY） -->
            <li class="Warning">
              {{ itemData.total_problem_refund_amount }}
            </li>
            <!-- 问题产品采购处理完成时间 -->
            <li class="Warning"></li>
            <!-- 采购成本 -->
            <li class="Warning">{{ itemData.total_purchase_cost }}</li>
            <!-- 退款凭证 -->
            <li class="Warning">

            </li>
            <!-- 1688该交易号是否发起售后 -->
            <li class="Danger"></li>
            <!-- 售后单号 -->
            <li class="Danger">

            </li>
            <!-- 售后状态 -->
            <li class="Danger flex05">

            </li>
            <!-- 1688该交易号售后完成时间 -->
            <li class="Danger">

            </li>
            <!-- 1688退款商品金额CNY -->
            <li>
              {{ itemData.total_refund_amount }}
            </li>
            <!-- 收入账号（支付宝/银行） -->
            <li class="Danger">

            </li>
            <!-- 到账状况 -->
            <li class="Danger flex05">

            </li>
            <!-- 退款到账时间 -->
            <li class="Danger">

            </li>
            <!-- 审核状态 -->
            <li class="flex05"></li>
            <!-- 财务审核备注 -->
            <li>

            </li>
            <!-- 操作 -->
            <li class="operation">

            </li>
          </ul>
          <ul v-for="(item, index) in itemData.details" :key="index">
            <!-- 客户订单号 -->
            <li>
              <p> <router-link :to="'/orderPaymentDetail?order_sn=' + item.order_sn" target="_blank" class="a-link">{{
                item.order_sn }}</router-link></p>

            </li>
            <!-- 商品信息 -->
            <li>
              <div class="template">
                <div class="goods">
                  <a :href="item.url.goods_url" target="_blank" c><img :src="item.pic" alt=""
                      style="width: 50px;height: 50px;margin-right: 5px;"></a>
                  <p>{{ item.goods_title }}</p>
                </div>
              </div>
            </li>
            <!-- 客户信息 -->
            <li>
              <div class="template">
                <p>{{ item.user_realname }}</p>
                <p>ID:{{ item.user_id }}</p>
                <p>
                  <attributeName :name="item.client_attribute.name" />
                </p>
              </div>
            </li>
            <!-- 退款数量 -->
            <li class="flex05">{{ item.problem_refund_goods_num }}</li>
            <!-- 问题产品退款商品金额（CNY） -->
            <li class="Warning">{{ item.problem_refund_goods_amount }}</li>
            <!-- 问题产品采购处理完成时间 -->
            <li class="Warning">{{ item.g_deal_at }}</li>
            <!-- 采购成本 -->
            <li class="Warning">{{ item.purchase_cost }}</li>
            <!-- 退款凭证 -->
            <li class="Warning">
              <div class="template">
                <el-image :src="item.problemGoodsImage" fit="contain" :preview-src-list="[item.problemGoodsImage]"
                  style="width: 50px;height: 50px;margin-right: 5px;">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline" style="font-size: 40px;"></i>
                  </div>
                </el-image>
              </div>
            </li>
            <!-- 1688该交易号是否发起售后 -->
            <li class="Danger">{{ item.has_refund == 1 ? '已有售后' : '否' }}</li>
            <!-- 售后单号 -->
            <li class="Danger">
              <div class="template">
                <p v-for="(afterSale, afterSaleIndex) in item.problemRefunds" :key="afterSaleIndex">{{
                  afterSale.refund_id
                }}</p>
              </div>
            </li>
            <!-- 售后状态 -->
            <li class="Danger flex05">
              <div class="template">
                <p v-for="(afterSale, afterSaleIndex) in item.problemRefunds" :key="afterSaleIndex">{{ afterSale.status
                }}
                </p>
              </div>
            </li>
            <!-- 1688该交易号售后完成时间 -->
            <li class="Danger">
              <div class="template">
                <p v-for="(afterSale, afterSaleIndex) in item.problemRefunds" :key="afterSaleIndex">{{
                  afterSale.complete_at }}</p>
              </div>
            </li>
            <!-- 1688退款商品金额CNY -->
            <li>
              <div class="template">
                <p v-for="(afterSale, afterSaleIndex) in item.problemRefunds" :key="afterSaleIndex">{{
                  afterSale.refund_payment }}</p>
              </div>
            </li>
            <!-- 收入账号（支付宝/银行） -->
            <li class="Danger">
              <div class="template">
                <p v-for="(afterSale, afterSaleIndex) in item.problemRefunds" :key="afterSaleIndex">{{
                  afterSale.buyer_alipay_id }}</p>
              </div>
            </li>
            <!-- 到账状况 -->
            <li class="Danger flex05">
              <div class="template">
                <p v-for="(afterSale, afterSaleIndex) in item.problemRefunds" :key="afterSaleIndex">
                  <span :style="{ color: afterSale.status == 'refundsuccess' ? 'green' : 'red' }">
                    {{ afterSale.status == 'refundsuccess' ? '已到账' : '未到账' }}
                  </span>
                </p>
              </div>
            </li>
            <!-- 退款到账时间 -->
            <li class="Danger">
              <div class="template">
                <p v-for="(afterSale, afterSaleIndex) in item.problemRefunds" :key="afterSaleIndex">{{
                  afterSale.complete_at }}</p>
              </div>
            </li>
            <!-- 审核状态 -->
            <li class="flex05">{{ item.audit_status_text }}</li>
            <!-- 财务审核备注 -->
            <li>
              <el-input v-model="item.audit_remark" placeholder="请输入财务审核备注" type="textarea"
                @blur="problemFinanceCheckUpdateAuditRemark(item)"></el-input>
            </li>
            <!-- 操作 -->
            <li class="operation">
              <div class="template" v-if="item.audit_status_text == '未审核'">
                <p @click="problem_goods.problem_goods_id = item.problem_goods_id" v-if="isAuth(687)">
                  <el-upload class="avatar-uploader" action="#" :show-file-list="false" :http-request="httpup"
                    :before-upload="beforeAvatarUpload">
                    <el-button type="primary" size="mini">凭证上传</el-button>
                  </el-upload>
                </p>
                <p>
                  <el-button type="primary" size="mini" @click="audit(item)" v-if="isAuth(683)">审核</el-button>
                </p>
              </div>
            </li>
          </ul>
        </div>

      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 审核弹窗 -->
    <el-dialog title="审核" :visible.sync="dialogVisible" width="450px">
      <div class="dialog-content">
        <!-- 财务审核备注 -->
        <el-input v-model="auditData.audit_remark" :placeholder="$t('message.financialAuditRemarks')"
          type="textarea"></el-input>
      </div>
      <template slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitAudit">{{ $t('message.submit') }}</el-button>
        <el-button @click="dialogVisible = false">{{ $t('message.cancel') }}</el-button>
      </template>
    </el-dialog>
    <!-- 仅按采购交易号查询，创建或作废后同步更新汇总行摘要。 -->
    <purchaseCashbackList ref="purchaseCashbackList" @latest-change="updateCashbackLatest" />
  </div>
</template>
<script>
import purchaseCashbackList from '@/views/problemDetail/components/purchaseCashbackList'

export default {
  components: {
    purchaseCashbackList,
  },
  data() {
    return {
      tableautoheight: window.innerHeight > 700 ? window.innerHeight - 180 : 800,
      dialogVisible: false,
      tab: [],
      datas: {
        audit_status: '',
        purchase_no: '',
        order_sn: '',
        user_id: '',
        y_id: '',
        g_id: '',
        p_id: '',
        page: 1,
        pageSize: 10,
        has_refund_image: '',
        has_refund: '',
      },
      total: 0,
      tableData: [],
      problem_goods: {
        problem_goods_id: '',
        refund_image: '',
      },
      loading: false,
      auditData: {
        id: '',
        audit_remark: '',
      },
    };
  },
  computed: {
    g() {
      return this.$store.state.authWorkGroupAdmin.g;
    },
    y() {
      return this.$store.state.authWorkGroupAdmin.y;
    },
    p() {
      return this.$store.state.authWorkGroupAdmin.p;
    },
  },
  created() {
    this.problemFinanceCheckListTab()
    this.problemFinanceCheckList()
  },

  methods: {
    // 列表tab统计
    problemFinanceCheckListTab() {
      this.$api.financialApi.problemFinanceCheckListTab().then(res => {
        this.tab = res.data
      })
    },
    // 列表
    problemFinanceCheckList() {
      this.$api.financialApi.problemFinanceCheckList(this.datas).then(res => {
        // 相同交易号共用摘要，收集当前页交易号后统一批量查询。
        const cashbackQueries = new Map()
        res.data.data.forEach(item => {
          const purchaseNo = item.purchase_no ? String(item.purchase_no) : ''
          if (!cashbackQueries.has(purchaseNo)) {
            cashbackQueries.set(purchaseNo, { purchase_no: purchaseNo, latest: null, requestId: 0 })
          }
          item.cashbackEntry = cashbackQueries.get(purchaseNo)
        })
        this.tableData = res.data.data
        this.total = res.data.total
        this.loadCashbackLatest(Array.from(cashbackQueries.values()))
        console.log(this.tableData);
      })
    },
    // 与问题产品页一致，一次提交交易号数组，再按purchase_no回填各行摘要。
    async loadCashbackLatest(entries) {
      if (!this.isAuth(781)) return
      const requests = entries.filter(entry => entry.purchase_no).map(entry => {
        entry.latest = null
        return { entry, requestId: ++entry.requestId }
      })
      if (!requests.length) return
      try {
        const res = await this.$api.problemApi.purchaseCashbackList({
          purchase_no: [...new Set(requests.map(({ entry }) => entry.purchase_no))],
          page: 1,
          pageSize: 100,
        })
        if (res.code !== 0) return
        const recordsByPurchaseNo = new Map()
        res.data.list.forEach(record => {
          const purchaseNo = String(record.purchase_no)
          if (!recordsByPurchaseNo.has(purchaseNo)) recordsByPurchaseNo.set(purchaseNo, [])
          recordsByPurchaseNo.get(purchaseNo).push(record)
        })
        requests.forEach(({ entry, requestId }) => {
          // 同一交易号已发起新查询时，旧批量响应不能覆盖最新摘要。
          if (entry.requestId !== requestId) return
          const records = recordsByPurchaseNo.get(entry.purchase_no) || []
          if (records.some(record => record.status !== 'voided')) entry.latest = records[0]
        })
      } catch (error) {
        // 查询失败时不展示金额，错误提示沿用公共请求层。
      }
    },
    // 收款弹框更新后只刷新对应交易号，不重置退款列表的筛选和分页。
    updateCashbackLatest({ purchase_no }) {
      const entries = new Set()
      this.tableData.forEach(item => {
        if (item.cashbackEntry.purchase_no === purchase_no) entries.add(item.cashbackEntry)
      })
      this.loadCashbackLatest(Array.from(entries))
    },
    // 搜索tab
    searchTabs(key) {
      this.datas.audit_status = key
      this.search()
    },
    // 搜索
    search() {
      this.datas.page = 1
      this.problemFinanceCheckList()
    },
    // 重置
    reset() {
      this.datas = {
        audit_status: '',
        purchase_no: '',
        order_sn: '',
        user_id: '',
        y_id: '',
        g_id: '',
        p_id: '',
        page: 1,
        pageSize: 10,
        has_refund_image: '',
        has_refund: '',
      }
      this.search()
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.problemFinanceCheckList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.problemFinanceCheckList();
    },
    // 补货订单-更新备注
    problemFinanceCheckUpdateAuditRemark(item) {
      this.$api.financialApi.problemFinanceCheckUpdateAuditRemark({
        id: item.id,
        audit_remark: item.audit_remark,
      })
    },
    //上传成功
    async httpup(file) {
      this.loading = false
      let data = await this.createClient(file)
      this.problem_goods.refund_image = data.data
      this.$api.problemApi.updateRefundImage(this.problem_goods).then((res) => {
        this.tableData.forEach(item => {
          if (item.problem_goods_id == this.problem_goods.problem_goods_id) {
            item.problemGoodsImage = this.problem_goods.refund_image
          }
        })
        this.$forceUpdate()
        this.$message.success(res.msg);
      });

    },
    // 上传前
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isSVG = file.type === "image/svg+xml";
      this.loading = true
      if (!isJPG && !isPNG && !isSVG) {
        this.$message.error("上传图片只能是 JPG,PNG 格式,SVG格式!");
        this.loading = false
      }
      return isJPG || isPNG || isSVG;
    },
    // 审核
    audit(item) {
      this.auditData = {
        id: item.id,
        audit_remark: item.audit_remark,
      }
      this.dialogVisible = true
    },
    // 提交审核
    submitAudit() {
      let datas = {
        id: this.auditData.id,
        audit_remark: this.auditData.audit_remark,
      }
      this.$api.financialApi.problemFinanceCheckAudit(datas).then(res => {
        this.$message({
          message: res.msg,
          type: 'success',
        })
        this.dialogVisible = false
        this.problemFinanceCheckList()
        this.problemFinanceCheckListTab()
      })
    },
  }
}
</script>
<style lang='scss' scoped>
.body {
  padding-bottom: 10px;
}

.search {
  display: flex;
  position: relative;
  margin: 0 0px 24px;

  .applyForDepositWithdrawalModification {
    position: absolute;
    top: 0;
    right: 0;
  }

  .item {
    width: 200px;
    margin-right: 12px;
  }
}

.tabs {
  display: flex;
  margin-bottom: 24px;

  .item {
    border: 1px solid #e4e7ed;
    padding: 10px 20px;
    cursor: pointer;

    &.active {
      background-color: #B4272D;
      color: #fff;
      border-color: #B4272D;
    }
  }
}

.table {
  overflow: auto;

  ol {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 10;

    height: 60px;
    width: 2000px;
    text-align: center;

    .Warning {
      background-color: #E6A23C;
      color: #fff;
    }

    .Danger {
      background-color: #F56C6C;
      color: #fff;
    }
  }

  ul {
    background-color: #fff;
    text-align: center;
    width: 2000px;
    padding: 0;

    li {
      padding: 10px 0;
    }
  }

  .operation {
    position: sticky;
    right: 0;
    background-color: #EDEFF4;
    z-index: 9;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    flex: 0.8;
  }

  .flex05 {
    flex: 0.5;
  }

  .flex2 {
    flex: 2;
  }

  .template {
    p {
      margin-bottom: 10px;

      &:nth-last-child(1) {
        margin: 0;
      }
    }
  }
}

/deep/.el-textarea__inner {
  height: 100px;
  padding: 5px !important;
}

.tableHead {
  background-color: #545467 !important;
  color: #fff !important;
}

/* 交易号、收款按钮和摘要保持单行，不撑开相邻退款统计列。 */
.cashback-header {
  flex-wrap: nowrap;
  min-width: 0;
  gap: 6px;
  font-size: 12px;
  white-space: nowrap;

  .purchase-number {
    min-width: 0;
    padding-left: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.cashback-entry {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  gap: 6px;

  .el-button {
    padding: 5px 6px;
  }
}

.cashback-latest {
  color: #C0C4CC;
  white-space: nowrap;

  &.paid {
    color: #67C23A;
  }

  &.pending {
    color: #F56C6C;
  }
}
</style>
